module.exports = __webpack_public_path__ + "static/image/history/pc/201012.ver2_0_2.jpg?d304d5ff";